export default __webpack_public_path__ + "static/media/edx.ade123bd.jpg";